export default __webpack_public_path__ + "static/grouped-column-d62a978e99bce0cc2a6fd833bb57c5b5.png";